import React from 'react';

import { XSS_FILTER_OPTIONS } from 'apps/auth/constants/Constants';
import { filterXSS } from 'xss';

import { Container, RowButton, SubTitle, Title } from './styles';
import { Button } from '../../Button/Button';
import type { ButtonProps } from '../../Button/Button';

interface HeaderPanelProps {
    isGlobalFlow?: boolean;
    indentCompact?: boolean;
    indentSmall?: boolean;
    isCentered?: boolean;
    title?: React.ReactNode;
    subtitle?: string;
    buttonRowType?: ButtonProps['type'];
    buttonRowCaption?: string;
    buttonRowOnClick?: React.MouseEventHandler<HTMLButtonElement>;
    buttonRowHref?: string;
    addTopMargin?: boolean;
    buttonRowSizeFit?: boolean;
}

export const HeaderPanel: React.FC<HeaderPanelProps> = (props) => {
    return (
        <Container $indentCompact={props.indentCompact} $indentSmall={props.indentSmall}>
            <Title $isCentered={props.isCentered}>{props.title}</Title>
            {props.subtitle && <SubTitle dangerouslySetInnerHTML={{ __html: filterXSS(props.subtitle, XSS_FILTER_OPTIONS) }} />}
            {!props.isGlobalFlow && props.buttonRowCaption && (
                <RowButton $addTopMargin={props.addTopMargin}>
                    <Button
                        type={props.buttonRowType}
                        variant="row"
                        size={props.buttonRowSizeFit ? 'fit' : 'tight'}
                        negativeMargin
                        caption={props.buttonRowCaption}
                        onClick={props.buttonRowOnClick}
                        href={props.buttonRowHref}
                    />
                </RowButton>
            )}
        </Container>
    );
};
